import { graphql } from '@/gql';

export const getExportedProduct = graphql(`
  query exportableProduct($id: ID!) {
    product(id: $id) {
      id
      name
      description
      lifecycleStatus
      productIdentifier
      projectIdentifier
      version
      updatedAt
      owner {
        id
        name
      }
      tailoringProcess {
        questions {
          __typename
          ...RadioQuestionFragment
          ...CheckboxQuestionFragment
        }
        buildingBlocks {
          id
          productId
          name
          targetState
          why
          consequencesOfNoResponse
          applicableFor
          preconditionAssumptions
          definitionOfDone
          inclusion {
            __typename
            actual
            source
            explanation
          }
          maturityStages {
            id
            name
            description
          }
          informations {
            id
            description
            link
            linkText
            classification
          }
          designObligation {
            id
            name
            description
            informations {
              id
              description
              link
              linkText
              classification
            }
          }
          dataBlocks {
            id
            name
            description
            definitionOfDone
            informations {
              id
              description
              link
              linkText
              classification
            }
          }
        }
        designObligations {
          id
          name
          description
          inclusion {
            inclusionOf
            actual
            recommended
            source
            explanation
            reevaluationRequest
          }
          informations {
            id
            description
            link
            linkText
            classification
          }
          buildingBlocks {
            id
            productId
          }
        }
        maturityStages {
          id
          name
          description
          triggeredDataBlocks {
            id
            name
          }
          followingMaturityStages {
            id
          }
        }

        dataBlocks {
          id
          name
          description
          definitionOfDone
          buildingBlocks {
            id
            productId
          }
          informations {
            id
            description
            link
            linkText
            classification
          }
          neededByDataBlocks {
            id
            name
            description
            definitionOfDone
          }
          triggeredDataBlocks {
            id
            name
            description
            definitionOfDone
          }
          successorDataBlocks {
            id
            name
            description
            definitionOfDone
          }
        }
      }
    }
  }
`);
